import React from 'react';
import * as ModoEdicion from '../../constantes/ModoEdicion.js';
import * as Imagenes from '../Iconos.js';
import styles from './Boton.module.css';

const BotonEdicion = (props) => {
  const id = props.id;
  const modo = props.modo;
  const estilo = props.estilo;

  const clickHandler = () => {
    props.onClick(id);
  };

  return (
    <button
      className={`${styles.botonTransparente} ${styles.botonEdicion} ${estilo}`}
      onClick={clickHandler}
    >
      <img
        className={styles.imgEdicion}
        key={id}
        id={id}
        src={modo === ModoEdicion.EDITAR ? Imagenes.editar : Imagenes.cancelar}
        alt={modo === ModoEdicion.EDITAR ? 'Editar' : 'Cancelar'}
      />
    </button>
  );
};

export default BotonEdicion;
